<script>
import { ref, onMounted } from 'vue';
import axiosInstance from '@/axiosConfig';
import { serverUrl } from '@/serverUrl';
import Swal from 'sweetalert2';

export default {
  name: 'KnifePage',

  setup() {
    const fileInput = ref(null);
    const files = ref([]);
    const imagePreviews = ref([]);
    const knifeTitle = ref('');
    const knifeText = ref('');
    const knifeDate = ref('');
    const knifeList = ref([]);

    const fetchKnife = async () => {
      try {
        const response = await axiosInstance.get('/upload/knife');
        knifeList.value = response.data;
      } catch (error) {
        console.error('Errore nel recupero delle knife:', error);
      }
    };

    const handleDrop = (event) => {
      event.preventDefault();
      const droppedFiles = event.dataTransfer.files;
      handleFiles(droppedFiles);
    };

    const openFileManager = () => {
      fileInput.value.click();
    };

    const handleFiles = (selectedFiles) => {
      for (let i = 0; i < selectedFiles.length; i++) {
        files.value.push(selectedFiles[i]);
        const reader = new FileReader();
        reader.onload = (e) => {
          imagePreviews.value.push({ url: e.target.result });
        };
        reader.readAsDataURL(selectedFiles[i]);
      }
    };

    const onFileChange = (event) => {
      const selectedFiles = event.target.files;
      handleFiles(selectedFiles);
    };

    const removeImage = (index) => {
      files.value.splice(index, 1);
      imagePreviews.value.splice(index, 1);
    };

    const publishKnife = async () => {
      const formData = new FormData();
      formData.append('titolo', knifeTitle.value);
      formData.append('testo', knifeText.value);
      formData.append('dataNews', knifeDate.value);

      for (let i = 0; i < files.value.length; i++) {
        formData.append('immagini', files.value[i]);
      }

      try {
        const response = await axiosInstance.post('/upload/knife', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        console.log('Knife pubblicata con successo:', response.data);
        Swal.fire('Successo!', 'La knife è stata pubblicata con successo.', 'success');
        resetForm();
        fetchKnife(); // Aggiorna l'elenco delle knife dopo la pubblicazione
      } catch (error) {
        console.error('Errore nel caricamento della knife:', error);
        Swal.fire('Errore!', 'Si è verificato un errore durante la pubblicazione della knife.', 'error');
      }
    };

    const deleteKnife = async (knifeId) => {
      Swal.fire({
        title: 'Sei sicuro?',
        text: "Questa operazione non può essere annullata!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sì, elimina!',
        cancelButtonText: 'Annulla'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axiosInstance.delete(`/upload/knife/${knifeId}`);
            console.log('Knife eliminata con successo:', response.data);
            Swal.fire('Eliminata!', 'La knife è stata eliminata con successo.', 'success');
            fetchKnife(); // Aggiorna l'elenco delle knife dopo l'eliminazione
          } catch (error) {
            console.error('Errore nell\'eliminazione della knife:', error);
            Swal.fire('Errore!', 'Si è verificato un errore durante l\'eliminazione della knife.', 'error');
          }
        }
      });
    };

    const resetForm = () => {
      knifeTitle.value = '';
      knifeText.value = '';
      knifeDate.value = '';
      files.value = [];
      imagePreviews.value = [];
    };

    const formatDate = (dateString) => {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('it-IT', options);
    };

    onMounted(() => {
      fetchKnife(); // Carica le knife all'avvio del componente
    });

    return {
      fileInput,
      knifeTitle,
      knifeText,
      knifeDate,
      handleDrop,
      openFileManager,
      onFileChange,
      publishKnife,
      imagePreviews,
      removeImage,
      knifeList,
      deleteKnife,
      formatDate,
      serverUrl
    };
  }
};
</script>

<template src="./KnifePage.html"/>

<style scoped></style>